import { useEffect, useRef, useState } from "react";
import "../css/FilterDropdown.css";
import { MdOutlineArrowDropDown } from "react-icons/md";

const FilterDropdown = ({
  options = [],
  onChange = () => {},
  value,
  placeholder = "",
  style = {},
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState([]);
  const [selectedItem, setSelectedItem] = useState(0);
  const optionsRef = useRef([]);
  const optionsContainerRef = useRef(null);

  useEffect(() => {
    if (value) {
      setSelectedOption(value);
    }
  }, [value]);

  const handleIsOpen = () => {
    setIsOpen((prev) => !prev);
  };

  const handleOptionClick = (isChecked, item) => {
    const selectedOptionText = options?.find((opt) => opt?.value === item);
    if (selectedOptionText) {
      setSelectedOption((prev) => {
        let updatedState = [];
        if (isChecked) {
          updatedState = [...prev, selectedOptionText?.value];
        } else {
          updatedState = prev?.filter((ele) => ele !== item);
        }
        onChange(updatedState);
        return updatedState;
      });
    }
  };

  const getSelectedOptions = (value) => {
    return selectedOption?.includes(value);
  };

  const handleKeyEvents = (e) => {
    if (e.key === "ArrowDown" && selectedItem < options.length - 1) {
      e.preventDefault();
      setSelectedItem((prev) => prev + 1);
      const selectedOptionElement = optionsRef.current[selectedItem + 1];
      if (selectedOptionElement) {
        const containerRect =
          optionsContainerRef.current.getBoundingClientRect();
        const optionRect = selectedOptionElement.getBoundingClientRect();
        if (optionRect.bottom > containerRect.bottom) {
          optionsContainerRef.current.scrollTop +=
            optionRect.bottom - containerRect.bottom;
        }
      }
    } else if (e.key === "ArrowUp" && selectedItem > 0) {
      e.preventDefault();
      setSelectedItem((prev) => prev - 1);
      const selectedOptionElement = optionsRef.current[selectedItem - 1];
      if (selectedOptionElement) {
        const containerRect =
          optionsContainerRef.current.getBoundingClientRect();
        const optionRect = selectedOptionElement.getBoundingClientRect();
        if (optionRect.top < containerRect.top) {
          optionsContainerRef.current.scrollTop -=
            containerRect.top - optionRect.top;
        }
      }
    } else if (e.key === "Enter") {
      e.preventDefault();
      optionsRef.current[selectedItem].click();
      //   setSelectedItem(0);
    }
  };

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (
        optionsContainerRef.current &&
        !optionsContainerRef.current.contains(event.target)
      ) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleOutsideClick);
    }

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [isOpen]);

  return (
    <div className="filter-cudropdown-input">
      <input
        type="text"
        onClick={handleIsOpen}
        // value={selectedOption}
        placeholder={placeholder}
        onKeyDown={handleKeyEvents}
        style={style}
        readOnly
        className="text-sm md:text-sm xl:text-sm 2xl:text-lg w-full h-full outline-none"
      />
      <span className="filter-cudropdown-clearable">
        <MdOutlineArrowDropDown size={21} />
      </span>
      {isOpen && (
        <div
          className="filter-cudropdown-options-menu"
          ref={optionsContainerRef}
        >
          {options?.map((opt, index) => (
            <div
              //   ref={(el) => (optionsRef.current[index] = el)}
              className={`filter-cudropdown-options-menu-item ${
                selectedItem === index
                  ? "filter-cudropdown-options-menu-item-active"
                  : ""
              }`}
              key={opt?.key}
              //   onClick={() => handleOptionClick(opt?.value)}
            >
              <span>{opt?.text}</span>
              <span>
                <input
                  type="checkbox"
                  checked={getSelectedOptions(opt?.value)}
                  className="cursor-pointer"
                  ref={(el) => (optionsRef.current[index] = el)}
                  onChange={(e) =>
                    handleOptionClick(e.target.checked, opt?.value)
                  }
                />
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default FilterDropdown;
